<template>
  <article>
    <Toolbar />

    <v-container fluid>
      <v-layout row wrap>
        <v-flex xs12 pa-2>

          <div v-if="$apollo.queries.incidents.loading">
            <v-progress-circular
              :size="70"
              :width="7"
              color="blue"
              indeterminate
            ></v-progress-circular>
          </div>
          <div v-else>
            <Summary :incidents="incidents" :apps="apps" />
          </div>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 pa-2>
          <div>
            <h3>Applications Overview</h3>
          </div>
          <div v-if="$apollo.queries.apps.loading">
            <v-progress-circular
              :size="70"
              :width="7"
              color="blue"
              indeterminate
            ></v-progress-circular>
          </div>
          <div v-for="app of apps" :key="app.name">
            <AppSummary
              :app="app"
              :timeLeft="2"
            />
          </div>
          <NewAppSLO :newApp="true" />
        </v-flex>
      </v-layout>
    </v-container>
  </article>
</template>

<script>
import AppSummary from "@/components/AppSummary";
import Summary from "@/components/Summary";
import NewAppSLO from "@/components/NewAppSLO";
import Toolbar from "@/components/Toolbar.vue";

import gql from "graphql-tag";

export default {
  components: {
    Toolbar,
    AppSummary,
    Summary,
    NewAppSLO
  },
  apollo: {
    apps: {
      query: gql`query {
        apps {
          name
          rateSlos {
            name
            currentErrorBudget {
              totalBudget
              remainingBudget
            }
          }
        }
      }`
    },
    incidents: {
      query: gql`query {
        incidents(filter: {onlyActive: true}) {
          severity
          started
          ended
          trigger {
            rateSlo {
              name
              app {
                name
              }
            }
          }
        }
      }`
    }
  },
  data() {
    return {
      apps: [],
      incidents: []
    };
  }
};
</script>
